export enum Theme {
  LIGHTZAM = 'lightZam',
  DARKZAM = 'darkZam',
  LIGHTDOTGOV = 'lightDotgov',
  DARKDOTGOV = 'darkDotGov',
}
